/**
 * Defines the layout type of the thumbnails list of the `ui5-media-gallery` component.
 * @public
 */
enum MediaGalleryLayout {

	/**
	 * The layout is determined automatically.
	 * @public
	 */
	 Auto = "Auto",

	/**
	 * Displays the layout as a vertical split between the thumbnails list and the selected image.
	 * @public
	 */
	Vertical = "Vertical",

	/**
	 * Displays the layout as a horizontal split between the thumbnails list and the selected image.
	 * @public
	 */
	Horizontal = "Horizontal",
}

export default MediaGalleryLayout;
